var ShoppingListAction = {
    /*
     Required external 'global' Vars:
     - shoppingListUrl
     - linkTextAdd
     - linkTextRemove
     */
    slBaseUrl: shoppingListUrl,

    initMyProductPromotionsShoppingListAction: function () {

        // Required external 'global' Vars:
        // - slProductPromotion
        var slMyPromotionsActionUrl = ShoppingListAction.slBaseUrl + "/my-product-promotion/";

        $(".alter-shoppinglist-productpromotion")
            .each(function () {
                ShoppingListAction.updateMyProductPromotionsStatus($(this));
            })
            .on("click", function () {
                var $self = $(this);
                ShoppingListAction.disableElement($self);

                var isInShoppingList = $self.data("is-in-shopping-list");
                var subItemRefId = $self.data("sub-item-ref-id");
                var slSubItemId = $self.data("sub-item-id");

                function addToShoppingList() {
                    $.ajax({
                        url: slMyPromotionsActionUrl + subItemRefId,
                        type: "POST",
                        headers: {
                            "Accept-Language": lang
                        },
                        success: function (responseData) {
                            $self.find(".patl--atl--text").html(linkTextRemove);
                            $self.data("is-in-shopping-list", true);
                            $self.data("sub-item-id", responseData.slSubItemId);
                            if(responseData.allProductPromotionsInSL) {
                                var $addAllMyProductPromotion = $("button.add-all-my-product-promotion");
                                if ($addAllMyProductPromotion.length) {
                                    $addAllMyProductPromotion.prop("disabled", true);
                                }
                            }
                            ShoppingListAction.enableElement($self);
                            ShoppingListAction.refreshNbItemsDisplay(responseData.shoppingListNbItems);
                        },
                        error: function (jqXHR) {
                            if (!TINK.redirectIfConflict(jqXHR)) {
                                ShoppingListAction.showError();
                            }
                        }
                    });
                }

                function removeFromShoppingList() {
                    $.ajax({
                        url: slMyPromotionsActionUrl + slSubItemId,
                        type: "DELETE",
                        headers: {
                            "Accept-Language": lang
                        },
                        success: function () {
                            $self.find(".patl--atl--text").html(linkTextAdd);
                            $self.data("is-in-shopping-list", false);
                            $self.data("sub-item-id", "");
                            var $addAllMyProductPromotion = $("button.add-all-my-product-promotion");
                            if ($addAllMyProductPromotion.length > 0) {
                                $addAllMyProductPromotion.prop("disabled", false);
                            }
                            ShoppingListAction.enableElement($self);
                        },
                        error: function (jqXHR) {
                            if (!TINK.redirectIfConflict(jqXHR)) {
                                ShoppingListAction.showError();
                            }
                        }
                    });
                }

                if (isInShoppingList) {
                    removeFromShoppingList();
                } else {
                    addToShoppingList();

                    var productDesc = $self.parents('.product-add-to-list').find('.patl--info').text().trim();
                    if(productDesc === null || productDesc === '') {
                        productDesc = $self.closest('.product-tile').find('.pt--info').text().trim();
                    }

                    pushDataLayerAddPersonalPromo(productDesc);
                }
            });

        $(".add-all-my-product-promotion")
            .on("click", function () {
                var $self = $(this);
                $.ajax({
                    url: ShoppingListAction.slBaseUrl + "/add-all-my-product-promotion",
                    type: "POST",
                    headers: {
                        "Accept-Language": lang
                    },
                    success: function (responseData) {
                        ShoppingListAction.disableElement($self);
                        location.reload(true);
                        ShoppingListAction.refreshNbItemsDisplay(responseData.shoppingListNbItems);
                    },
                    error: function (jqXHR) {
                        if (!TINK.redirectIfConflict(jqXHR)) {
                            ShoppingListAction.showError();
                        }
                    }
                });
            });
    },

    initMyUsualShoppingListAction: function () {

        // Required external 'global' Vars:
        // - slUsualProducts
        var slMyUsualActionUrl = ShoppingListAction.slBaseUrl + "/my-usual/";
        $(".alter-shoppinglist")
            .each(function () {
                ShoppingListAction.updateMyUsualsStatus($(this));
            })
            .on("click", function () {
                var $self = $(this);
                ShoppingListAction.disableElement($self);

                var isInShoppingList = $self.data("is-in-shopping-list");
                var subItemRefId = $self.data("sub-item-ref-id");
                var slSubItemId = $self.data("sub-item-id");

                function addToShoppingList(responseData) {
                    $.ajax({
                        url: slMyUsualActionUrl + subItemRefId,
                        type: "POST",
                        headers: {
                            "Accept-Language": lang
                        },
                        success: function (responseData) {
                            $self.find(".patl--atl--text").html(linkTextRemove);
                            $self.data("is-in-shopping-list", true);
                            $self.data("sub-item-id", responseData.slSubItemId);
                            if (responseData.allUsualsInSL) {
                                $("button.add-all-my-usuals").prop("disabled", true);
                            }
                            ShoppingListAction.enableElement($self);
                            ShoppingListAction.refreshNbItemsDisplay(responseData.shoppingListNbItems);
                        },
                        error: function (jqXHR) {
                            if (!TINK.redirectIfConflict(jqXHR)) {
                                ShoppingListAction.showError();
                                ShoppingListAction.enableElement($self);
                            }
                        }
                    });
                }

                function removeFromShoppingList() {
                    $.ajax({
                        url: slMyUsualActionUrl + slSubItemId,
                        type: "DELETE",
                        headers: {
                            "Accept-Language": lang
                        },
                        success: function () {
                            $self.find(".patl--atl--text").html(linkTextAdd);
                            $self.data("is-in-shopping-list", false);
                            $self.data("sub-item-id", "");
                            if($("button.add-all-my-usuals").length > 0) {
                                $("button.add-all-my-usuals").prop("disabled", false);
                            }
                            ShoppingListAction.enableElement($self);
                        },
                        error: function (jqXHR) {
                            if (!TINK.redirectIfConflict(jqXHR)) {
                                ShoppingListAction.showError();
                                ShoppingListAction.enableElement($self);
                            }
                        }
                    });
                }

                if (isInShoppingList) {
                    removeFromShoppingList();
                } else {
                    addToShoppingList();

                    var productDesc = $self.parents('.product-add-to-list').find('.patl--info').text().trim();
                    if(productDesc === null || productDesc === '') {
                        productDesc = $self.closest('.product-tile').find('.pt--info').text().trim();
                    }
                    pushDataLayerAddUsuals(productDesc);
                }
            });

        $(".add-all-my-usuals")
            .on("click", function () {
                var $self = $(this);
                $.ajax({
                    url: ShoppingListAction.slBaseUrl + "/add-all-my-usual",
                    type: "POST",
                    headers: {
                        "Accept-Language": lang
                    },
                    success: function (responseData) {
                        ShoppingListAction.disableElement($self);
                        location.reload(true);
                        ShoppingListAction.refreshNbItemsDisplay(responseData.shoppingListNbItems);
                    },
                    error: function (jqXHR) {
                        if (!TINK.redirectIfConflict(jqXHR)) {
                            ShoppingListAction.showError();
                        }
                    }
                });
            });
    },

    initIngredientsShoppingListAction: function () {

        $(".alter-shoppinglist-ingredients")
            .each(function () {
                ShoppingListAction.updateIngredientStatus($(this));
            })
            .on("click", function () {
                var $self = $(this);
                ShoppingListAction.disableElement($self);

                var isInShoppingList = $self.data("is-in-shopping-list");

                if (isInShoppingList) {
                    var slIngredientsDeleteActionUrl = ShoppingListAction.slBaseUrl + "/ingredient/";
                    var slSubItemId = $self.data("sub-item-id");
                    ShoppingListAction.callRemoveFromShoppingList(slIngredientsDeleteActionUrl, slSubItemId, $self, function () {
                        var addAllIngredientButton = $("button.alter-shoppinglist-add-all-ingredients");
                        addAllIngredientButton.prop("disabled", false);
                        ShoppingListAction.showHideIconLink(addAllIngredientButton, true);
                    });
                } else {
                    var recipeUrl = $self.data("recipe-url");
                    var slIngredientsAddActionUrl = ShoppingListAction.slBaseUrl + "/recipe/" + recipeUrl + "/ingredient/";
                    var subItemRefId = $self.data("sub-item-ref-id");
                    ShoppingListAction.callAddToShoppingList(slIngredientsAddActionUrl, subItemRefId, $self, function(responseData) {
                        if (responseData.allIngredientsInSL) {
                            var addAllIngredientButton = $("button.alter-shoppinglist-add-all-ingredients");
                            addAllIngredientButton.prop("disabled", true);
                            ShoppingListAction.showHideIconLink(addAllIngredientButton, false);
                        }
                        pushDataLayerRecipeAddToList();
                    });
                }
            });

        $(".alter-shoppinglist-add-all-ingredients")
            .on("click", function () {
                var $self = $(this);

                ShoppingListAction.disableElement($self);

                var recipeUrl = $self.data("recipe-url");

                var $slAllIngredientsTitle = addeableIngredientNames.join("|");

                $.ajax({
                    url: ShoppingListAction.slBaseUrl + "/recipe/" + recipeUrl,
                    type: "POST",
                    headers: {
                        "Accept-Language": lang
                    },
                    success: function (responseData) {
                        ShoppingListAction.disableElement($self);
                        location.reload(true);
                        ShoppingListAction.refreshNbItemsDisplay(responseData.shoppingListNbItems);
                    },
                    error: function (jqXHR) {
                        if (!TINK.redirectIfConflict(jqXHR)) {
                            ShoppingListAction.showError();
                        }
                    }
                });

                pushDataLayerRecipeAddToList(true);
            });

    },

    disableElement: function ($self) {
        $self.prop("disabled", true);
    },

    enableElement: function ($self) {
        $self.prop("disabled", false);
    },

    callRemoveFromShoppingList: function (baseUrl, slSubItemId, $self, callback) {
        $.ajax({
            url: baseUrl + slSubItemId,
            type: "DELETE",
            headers: {
                "Accept-Language": lang
            },
            success: function (responseData) {
                ShoppingListAction.setLinkAdd($self);
				ShoppingListAction.enableElement($self);

                if (typeof callback !== "undefined") {
                    callback(responseData);
                }
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    ShoppingListAction.showError();
                    ShoppingListAction.enableElement($self);
                }
            }
        });
    },

    callAddToShoppingList: function (actionURL, subItemRefId, $self, callback) {
    	var urlToCall = vitrineUrl + actionURL + subItemRefId;
    	$.ajax({
            url: urlToCall,
            type: "POST",
            xhrFields: {
		      withCredentials: true
		   },
            headers: {
                "Accept-Language": lang
            },
            success: function (responseData) {
                ShoppingListAction.setLinkRemove($self, responseData.slSubItemId);
                ShoppingListAction.enableElement($self);
				ShoppingListAction.refreshNbItemsDisplay(responseData.shoppingListNbItems);

                if (typeof callback !== "undefined") {
                    callback(responseData);
                }

            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    ShoppingListAction.showError();
                    ShoppingListAction.enableElement($self);
                }
            }
        });
    },

    showError: function () {
        $("#ok-box").click(function () {
            location.reload(true);
        });
        $.fancybox({
            href: "#errors",
            modal: true
        });
        $("#errors").attr("tabindex","0").find("h3").focus();
    },

    setLinkRemove: function ($self, subItemId) {
		var withSpan = $self.find('span').length > 0 ? true : false;
		
        if(ShoppingListAction.isIconLink($self)){
            ShoppingListAction.showHideIconLink($self, false);
        } else if(withSpan) {
			if($self.find('.removeShoppinglistProductLabel')) {
				$self.find('.removeShoppinglistProductLabel').removeClass('hide');
				$self.find('.addShoppinglistProductLabel').addClass('hide');
			} else {
				$self.find('span').html(linkTextRemove);
			}
        } else {
			$self.html(linkTextRemove);
		}
        $self.data("is-in-shopping-list", true);
        $self.data("sub-item-id", subItemId);
    },

    setLinkAdd: function ($self) {
		var withSpan = $self.find('span').length > 0 ? true : false;
		
        if(ShoppingListAction.isIconLink($self)){
            ShoppingListAction.showHideIconLink($self, true);
        } else if(withSpan) {
			if($self.find('.addShoppinglistProductLabel')) {
				$self.find('.addShoppinglistProductLabel').removeClass('hide');
				$self.find('.removeShoppinglistProductLabel').addClass('hide');
			} else {
				$self.find('span').html(linkTextAdd);
			}
        } else {
			$self.html(linkTextAdd);
		}
        $self.data("is-in-shopping-list", false);
    },

    showHideIconLink: function($self, active){
        if(active) {
            $self.removeClass('is_active');
            $self.attr("title", linkTextAdd);
        } else {
			$self.addClass('is_active');
            $self.attr("title", linkTextRemove);
        }
	},

    isIconLink: function($self) {
       return $self.find("svg.addeable-list-icon,img.addeable-list-icon").length > 0;
    },

    updateMyUsualsStatus: function ($self) {
        if (slUsualProducts == undefined) {
            console.warn('Missing required info slUsualProducts');
        }
        var subItemRefId = $self.data("sub-item-ref-id");
        var slProductInfo = _.findWhere(slUsualProducts, {subItemReferenceId: subItemRefId});
        var isInShoppingList = slProductInfo != undefined;

        if (isInShoppingList) {
            var subItemId = slProductInfo.subItemId;
            $self.find(".patl--atl--text").html(linkTextRemove);
            $self.data("is-in-shopping-list", true);
            $self.data("sub-item-id", subItemId);
        }
    },

    updateMyProductPromotionsStatus: function ($self) {
        if (slProductPromotion == undefined) {
            console.warn('Missing required info slProductPromotion');
        }
        var subItemRefId = $self.data("sub-item-ref-id");
        var slProductPromotionInfo = _.findWhere(slProductPromotion, {subItemReferenceId: subItemRefId});
        var isInShoppingList = slProductPromotionInfo != undefined;

        if (isInShoppingList) {
            var subItemId = slProductPromotionInfo.subItemId;
            $self.find(".patl--atl--text").html(linkTextRemove);
            $self.data("is-in-shopping-list", true);
            $self.data("sub-item-id", subItemId);
        }
    },

    updateIngredientStatus: function ($self) {
        if (slIngredients == undefined) {
            console.warn('Missing required info slIngredients');
        }
        var subItemRefId = $self.data("sub-item-ref-id");
        var slIngredientInfo = _.findWhere(slIngredients, {subItemReferenceId: subItemRefId});

        var isInShoppingList = slIngredientInfo != undefined;

        if (isInShoppingList) {
            ShoppingListAction.setLinkRemove($self, slIngredientInfo.subItemId);
        } else {
            ShoppingListAction.setLinkAdd($self);
        }
    },

    refreshNbItemsDisplay: function (nbItems) {
        $('.mlb--number').html(nbItems);
    }
};
